module.exports = __webpack_public_path__ + "img/836230.dfe41b80.jpg";